import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ExpandedContentService } from '../../services/expanded-content.service';
import { AltText, Chart } from 'src/app/shared/interfaces';
import { FeatureFlagService } from 'src/app/modules/feature-flags/services/feature-flag/feature-flag.service';
import { FeatureFlags } from 'src/app/shared/enums/feature-flags';
import { ScaleToFitService } from 'src/app/shared/services/scale-to-fit/scale-to-fit.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'htc-expandable-wrapper',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, TranslateModule],
  providers: [ScaleToFitService],
  templateUrl: `./expandable-wrapper.component.html`,
  styleUrl: './expandable-wrapper.component.scss',
})
export class ExpandableWrapperComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('expandableContentContainer', { static: true })
  contentContainer!: ElementRef;
  @Input() imageSrc!: string;
  @Input() imageAlt!: AltText[];
  @Input() chart!: Chart;
  @Input() set isContentLoaded(isContentLoaded: boolean) {
    if (isContentLoaded) {
      this._isContentLoaded = isContentLoaded;
      this.scaleToFit();
    }
  }
  @Input() isFlexCentered = false;
  _isContentLoaded = false;
  disabled = false;
  scaledValue = 1;
  width = 0;
  sub = new Subscription();

  constructor(
    private cdr: ChangeDetectorRef,
    public scaleToFitService: ScaleToFitService,
    private expandedContentService: ExpandedContentService,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit(): void {
    this.disabled = !this.featureFlagService.isFlagEnabled(
      FeatureFlags.EXPANDABLE_CONTENT
    );
    if (this.chart) {
      this.sub.add(
        this.scaleToFitService.scale.subscribe(scale => {
          this.scaledValue = scale;
        })
      );
    }
  }

  ngAfterViewInit(): void {
    if (this.chart) {
      this.scaleToFitService.elementToScale =
        this.contentContainer.nativeElement;

      this.scaleToFit();
    }
  }

  @HostListener('window:resize', ['$event'])
  scaleToFit(_event?: Event): void {
    if (this.chart) {
      this.scaleToFitService.handleFit().catch(err => {
        console.log(err);
      });
    }
  }

  openModal(): void {
    if (this.chart) {
      this.expandedContentService.openChart(this.chart);
    } else if (this.imageSrc) {
      this.expandedContentService.openImage(this.imageSrc, this.imageAlt);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
